// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnimatedRoute_wrapper__2Epum"};